import { TFunction } from 'react-i18next';

export const getCardTransactionsChipProps = (cardTransactionStatus: string, t: TFunction) => {
  const executedStatus = t('cardTransactionStatus.Executed');
  const pendingStatus = t('cardTransactionStatus.Pending');
  const failedStatus = t('cardTransactionStatus.Failed');

  switch (cardTransactionStatus) {
    case executedStatus.toUpperCase():
      return { value: executedStatus, color: 'success' };
    case failedStatus.toUpperCase():
      return { value: failedStatus, color: 'error' };
    default:
      return {
        value: pendingStatus,
        color: 'warning',
      };
  }
};
